import React, { useCallback, useMemo, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import { CloseRounded } from '@material-ui/icons'
import { useListInfographicBlocks } from '../../hooks/useListInfographicBlocks'
import SydInput from '../../../../../commonDesign/SydInput'
import Loading from '../../../../../molecules/Loading'
import SydButton from '../../../../../commonDesign/Button'
import { usePreviewDisplayContext } from '../../components/PreviewDisplayContext'
import { getRandomId } from '../../../../../organisms/EntityGraph/NodeLinkComponents/utils'
import { InfographicBlockListItem } from './InfographicBlockListItem'

const useStyles = makeStyles((theme) => ({
  infographicBlocksList: {
    maxHeight: '400px',
    overflowX: 'hidden',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: '50px',
    '& > *:nth-child(2n)': {
      backgroundColor: 'var(--color-neutral-100)'
    }
  },
  gradient: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: '50px',
    backgroundImage: 'linear-gradient(transparent, var(--card-bg-color))',
    pointerEvents: 'none'
  }
}))

export const InfographicBlockList = ({
  sizeFilter,
  onAddBlockToPage
}) => {
  const classes = useStyles()
  const { setSelectedBlockId } = usePreviewDisplayContext()
  const { data, isLoading } = useListInfographicBlocks()

  const [searchTerm, setSearchTerm] = useState('')

  const filteredBlocks = useMemo(() => {
    if (!data?.length || !sizeFilter) return []
    return data?.filter(block => {
      const size = block.metadata?.size
      const matchesSizeFilter = sizeFilter.cols >= size.cols && sizeFilter.rows >= size.rows
      const matchesSearchTerm = block.name.toLowerCase().includes(searchTerm.toLowerCase()) || block.reportObjects?.some(ro => ro.name.toLowerCase().includes(searchTerm.toLowerCase()))

      return matchesSizeFilter && matchesSearchTerm
    })
  }, [data, searchTerm, sizeFilter])

  const handleOnAddBlockToPage = useCallback((block) => {
    onAddBlockToPage({
      ...block,
      key: `${block.infographicBlockId}_${getRandomId()}`
    })
  }, [onAddBlockToPage])

  return (
    <div className={classes.infographicBlocksContainer}>
      <div className='p-md flex justify-between items-center gap-2'>
        <SydInput
          size='sm'
          iconName='search'
          placeholder='Search blocks'
          onChange={(e) => setSearchTerm(e.target.value)}
          value={searchTerm}
        />
        <SydButton type='ghost' size='xs' onClick={() => setSelectedBlockId(null)} style={{ minWidth: 0, padding: 'var(--padding-xs)' }}>
          <CloseRounded fontSize='small' />
        </SydButton>
      </div>
      <div className={classes.infographicBlocksList}>
        {isLoading && <Loading />}
        {filteredBlocks?.map((block, i) => (
          <InfographicBlockListItem
            key={i}
            block={block}
            onAddBlockToPage={handleOnAddBlockToPage}
          />
        ))}
      </div>
      <div className={classes.gradient} />
    </div>
  )
}

InfographicBlockList.propTypes = {
  sizeFilter: PropTypes.shape({
    cols: PropTypes.number,
    rows: PropTypes.number
  }),
  onAddBlockToPage: PropTypes.func
}
